import { WsApi, SecuredWsApi } from "@/utils/http-client";

export default {
  getOnboardingDetails(onboardingToken) {
    return WsApi.get(`/api/payer-onboarding/v1/${onboardingToken}`);
  },
  getPayerDetails(onboardingToken) {
    return SecuredWsApi.get(`/api/payer-onboarding/v1/${onboardingToken}/payer-details`);
  },
  updatePayerDetails(payerUserId, payload) {
    return SecuredWsApi.put(`/api/payer-onboarding/v1/${payerUserId}/payer-details`, payload);
  },
  acceptTerms(onboardingToken, termsId) {
    return WsApi.post(`/api/payer-onboarding/v1/${onboardingToken}/terms-accepted`, {
      payerOnboardingTermsId: termsId,
    });
  },
  createPayerPassword(onboardingToken, password) {
    return WsApi.post("/authentication/create-password", {
      payerOnboardingToken: onboardingToken,
      password,
    });
  },
  onboardPayer(onboardingToken, payload) {
    return SecuredWsApi.post(`/api/payer-onboarding/v1/${onboardingToken}/onboard-payer`, payload);
  },
};
